export const url = {
  fetchServices: () => `api/services/`,
  fetchDetail: (id) =>
    `api/services/${id}?populate[image]=*&populate[sections][populate][0]=tabs.service_tables.row.value`,
  submitContactUs: () => `/contact_us`,
};
